

const master = () => {
    const url = "https://api-roomguli.shafiqsuhag.com"
    
    return url; 
};

export const clientSideUrl = () => {
    const url = "https://roomguli.vercel.app/"
    // const url = "http://localhost:3000/"
    
    
    return url; 
}

export const ImageApiUrl = () => {
    
    return `${master()}/public/public/uploads/`
    // return `${master()}/public/uploads/`
   
};

export default master;